import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { setupInstallPrompt, registerPWA, lockPortraitOrientation } from '@/lib/pwa';

// Setup PWA install prompt listener early to capture the event
setupInstallPrompt();

// Register PWA service worker
registerPWA();

// Lock orientation to portrait on mobile/PWA. Internal audience only — the call is a
// no-op for a stored client session, because the customer portal has to work on a tablet
// in landscape (see lockPortraitOrientation / unlockOrientation in @/lib/pwa).
lockPortraitOrientation();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error(
    'Failed to find the root element. Make sure there is a <div id="root"></div> in your index.html.'
  );
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
